import IconStatiItem from 'components/general/IconStatItem';
import React from 'react';
import styled from 'styled-components';
import { border } from 'variables/general';

const Component = styled.div`
  &:not(:last-of-type) {
    margin-bottom: 1.5em;
    padding-bottom: 1.5em;
    border-bottom: ${border};
  }
`;

const Heading = styled.h6`
  margin-bottom: 2em;
  text-transform: uppercase;
`;

const InfoSection = ({ heading, data }) => (
  <Component>
    <Heading>{heading}</Heading>
    {data.map(({ icon, description }) => (
      <IconStatiItem icon={icon} description={description} />
    ))}
  </Component>
);

export default InfoSection;
